module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero-head"
  }, [_c('header', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-brand",
    attrs: {
      "href": "index.html"
    }
  }, [_c('p', {
    staticClass: "title is-4-mobile"
  }, [_vm._v("Ignacio Del Nardo")])])]), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://github.com/mrignacio1231"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])]), _c('a', {
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "https://www.linkedin.com/in/ignaciodelnardo/"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])]), _c('span', {
    staticClass: "nav-toggle"
  }, [_c('span'), _c('span'), _c('span')]), _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('a', {
    staticClass: "nav-item is-active",
    attrs: {
      "data-scroll": "",
      "href": "#inicio"
    }
  }, [_vm._v("Home")]), _c('a', {
    staticClass: "nav-item",
    attrs: {
      "data-scroll": "",
      "href": "#projects"
    }
  }, [_vm._v("Proyectos")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-039e7d48!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/views/MenuBar.pug
// module id = 16
// module chunks = 0